<template>
  <div>
    <div class="modal" v-bind:class="[show ? 'is-active' : '']">
      <div class="modal-background"></div>
      <div class="modal-content">
        <div id="modalMap"></div>
      </div>
      <button class="modal-close is-large" aria-label="close" @click="close_modal"></button>
    </div>
  </div>
</template>

<script>
import 'leaflet/dist/leaflet.css'
import L from 'leaflet'
import {T_STD, T_PALE, O_STD, BASEGIS} from '../../util.js'

export default {
  data:function (){
    return {
      Map_BaseLayer: {
        "地理院地図 標準": T_STD,
        "地理院地図 淡色": T_PALE,
        "地理院地図 航空写真": BASEGIS,
        "OpenStreetMap 標準": O_STD
      },
      map: null,
      show: false,
      mapOptions: {
        zoom: 18
      }
    }
  },
  props:{
    location: {
      type: Object,
      default: null,
    },
  },
  methods:{
    close_modal(){
      this.show = false
    },
    invalidateSize: function(){
      //マップが画面半分しか更新されない（バグ？）ための対応
      this.map.invalidateSize(this.mapOptions.zoom)
    },
    map_show(){
      this.show = true
      setTimeout(this.invalidateSize, 500);
      if(this.map !== null) return;
      this.map = L.map('modalMap',
        {
          center: L.latLng( this.location.task.lat, this.location.task.lon ),
          zoom: this.mapOptions.zoom,
          layers:[ new L.tileLayer('https://cyberjapandata.gsi.go.jp/xyz/std/{z}/{x}/{y}.png', {
            attribution: "<a href='http://www.gsi.go.jp/kikakuchousei/kikakuchousei40182.html' target='_blank'>国土地理院</a>"
          })]
        }
      )
      let marker = L.marker(L.latLng( this.location.task.lat, this.location.task.lon ), {
        icon: L.icon({
          iconUrl: 'static/nanikamitsuketa_mitsuketazou.gif',
          iconSize: [48, 48],
        }),
        draggable: false,
      })
      this.map.addLayer(marker)
      //コントロールの追加
      L.control.layers(this.Map_BaseLayer, null, {
        collapsed: true
      }).addTo(this.map)
    },
  }
}
</script>

<style scope>
  #modalMap {
    width: 100%;
    height: calc(100vh - 60px);
  }
  .is-active {
    z-index: 9999;
  }
</style>